import colors from '@rategravity/frontend/theme/colors';
import React from 'react';
import Dashboard from '../../components/dashboard';

const defaultStyle = {
  container: {
    maxWidth: 620,
    color: colors.primary,
    margin: 'auto',
    marginTop: '0px'
  },
  articleContainer: {
    backgroundColor: '#FFFFFF',
    padding: '1em',
    maxWidth: 440
  },
  articleTitle: {
    marginBottom: '1em'
  },
  article: {
    margin: '.5em 0'
  },
  prompt: { fontSize: '1.3em' },
  row: { paddingBottom: '10px', paddingTop: '10px' }
};

const Article = ({ href, children, style }) => (
  <p style={style}>
    <a href={`https://resources.ownup.com/${href}`}>{children}</a>
  </p>
);

const GenericDashboard = ({
  message,
  subheader,
  articles,
  props,
  children = null,
  style = defaultStyle
}) => (
  <Dashboard {...props}>
    <div style={style.container}>
      <br />
      <div style={{ ...style.row }}>
        <h1>{message}</h1>
      </div>
      <div style={{ ...style.prompt, ...style.row }}>{subheader}</div>
      <br />
      <br />
      {articles.length > 0 ? (
        <div style={style.articleContainer}>
          <h5 style={style.articleTitle}>Related Articles</h5>
          {articles.map((article, i) => (
            <Article key={i} href={article.href} style={style.article}>
              {article.title}
            </Article>
          ))}
        </div>
      ) : null}
    </div>
    {children}
  </Dashboard>
);

export default GenericDashboard;



// WEBPACK FOOTER //
// ./src/products/shared/generic-dashboard.js